import { RootSchema } from "../../../redux/reducers";
import { AnalyticsEvent } from "../types";
import { mapStaticMutation } from "./helpers";

export const mapCustomIdpAnalyticsEvents = (previousState: RootSchema, currentState: RootSchema): AnalyticsEvent[] => [
  ...mapStaticMutation(previousState.platformConfiguration?.postSAMLProviders, currentState.platformConfiguration?.postSAMLProviders, {
    successEventName: "custom_provider_configured_custom_idp",
    errorEventName: "custom_provider_got_idp_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.putSAMLProviders, currentState.platformConfiguration?.putSAMLProviders, {
    successEventName: "custom_provider_configured_custom_idp",
    errorEventName: "custom_provider_got_idp_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.deleteSAMLProviders, currentState.platformConfiguration?.deleteSAMLProviders, {
    successEventName: "custom_provider_deleted_custom_idp",
    errorEventName: "custom_provider_got_idp_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.postJWTProviders, currentState.platformConfiguration?.postJWTProviders, {
    successEventName: "custom_provider_configured_custom_idp",
    errorEventName: "custom_provider_got_idp_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.putJWTProviders, currentState.platformConfiguration?.putJWTProviders, {
    successEventName: "custom_provider_configured_custom_idp",
    errorEventName: "custom_provider_got_idp_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.deleteJWTProviders, currentState.platformConfiguration?.deleteJWTProviders, {
    successEventName: "custom_provider_deleted_custom_idp",
    errorEventName: "custom_provider_got_idp_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.setAuthServerConfigApi, currentState.platformConfiguration?.setAuthServerConfigApi, {
    successEventName: "custom_provider_configured_custom_idp",
    errorEventName: "custom_provider_got_idp_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.updateAuthServerConfigAPi, currentState.platformConfiguration?.updateAuthServerConfigAPi, {
    successEventName: "custom_provider_configured_custom_idp",
    errorEventName: "custom_provider_got_idp_error"
  }),
  ...mapStaticMutation(previousState.platformConfiguration?.deleteAuthServerConfigApi, currentState.platformConfiguration?.deleteAuthServerConfigApi, {
    successEventName: "custom_provider_deleted_custom_idp",
    errorEventName: "custom_provider_got_idp_error"
  })
];
